module.exports = __webpack_public_path__ + "static/media/70s_thumb.5302ccc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/trends/70s_thumb.png
// module id = 333
// module chunks = 0